var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBird = function SvgIconBird(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 8.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M12.166 13.358a1 1 0 1 0-1.589-1.216l-2.868 3.75a1 1 0 1 0 1.588 1.216z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M13.879 1.306a5.875 5.875 0 0 1 6.316 3.958l2.109 1.403a1 1 0 0 1 0 1.665L20.5 9.535v1.715a10 10 0 0 1-10 10H1.125a1 1 0 0 1-.794-1.608L8.75 8.66V7.123a5.875 5.875 0 0 1 5.129-5.817m2.913 2.615a3.875 3.875 0 0 0-6.042 3.205V9a1 1 0 0 1-.206.608L3.152 19.25H10.5a8 8 0 0 0 8-8V9a1 1 0 0 1 .445-.832l1.001-.667-1.16-.772a1 1 0 0 1-.413-.579 3.88 3.88 0 0 0-1.58-2.23",
    clipRule: "evenodd"
  }))));
};
export default SvgIconBird;